import { render } from "./Topicos.vue?vue&type=template&id=1a3667d7&scoped=true"
import script from "./Topicos.vue?vue&type=script&lang=js"
export * from "./Topicos.vue?vue&type=script&lang=js"

import "./Topicos.vue?vue&type=style&index=0&id=1a3667d7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3667d7"]])

export default __exports__